import { GROUP_LIST, ENGINEER_LIST, ENGINEER_ADMINS, USER_GET, USER_LIST, ROLE_LIST, USER_ADD, LOGOUT_USER, LOGIN_USER, COURSE_GROUP_LIST, USERS_BY_COURSE_GROUPS } from './types'
import { Api } from '../../components/Api'
import { toast } from "react-toastify";


export const authAzure = () => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        let url: any = "https://login.microsoftonline.com/2e9ce4de-1961-453a-bbb3-55cf28409943/oauth2/v2.0/authorize?client_id=067dd641-4a24-4bf2-8561-0af097be210b&scope=user.read%20openid%20profile%20offline_access&redirect_uri=http%3A%2F%2Flocalhost%3A3005%2Fauthentication%2Fbrowser-callback&client-request-id=16e98268-c693-44d4-8a6e-cd1673bf18c6&response_mode=query&response_type=code&x-client-SKU=msal.js.node&x-client-VER=1.2.0&x-client-OS=win32&x-client-CPU=x64&client_info=1"
        Api.get(url, {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Access-Control-Allow-Origin': '*'
            }
        })
            .then((response) => {
                console.log("sessadsd", response);
                // if(response.data.success){
                //     //sessionStorage.setItem('ticketLength', response.data.successResponse.length);
                //     dispatch({
                //         type: TICKET_LIST,
                //         payload: response.data.successResponse
                //     })
                // }
            }).catch(err => {
                if (err.response) {
                    console.log(err)
                } else {
                    alert(err.message)
                }
            });
    }
}

export const groupList = () => {
    return function (dispatch: any) {
        // console.log("JAWAD SHAH");

        let token: any = sessionStorage.getItem('token');
        Api.get('/user/getGroups', {
            headers: { 'Authorization': 'Bearer ' + token }
        }).then((response) => {
            console.log("response", response.data.data);
            dispatch({
                type: GROUP_LIST,
                payload: response.data.data
            })

        }).catch(err => {
            console.log("err", err);
            if (err.response) {
                console.log(err.response.data.message)
            } else {
                alert(err.message)
            }
        });
    }
}
export const roleList = () => {
    return function (dispatch: any) {
        console.log("JAWAD SHAH");

        let token: any = sessionStorage.getItem('token');
        Api.get('/user/getAllRoles', {
            headers: { 'Authorization': 'Bearer ' + token }
        }).then((response) => {
            console.log("response", response);
            dispatch({
                type: ROLE_LIST,
                payload: response.data.data
            })

        }).catch(err => {
            console.log("err", err);
            if (err.response) {
                console.log(err.response.data.message)
            } else {
                alert(err.message)
            }
        });
    }
}

export const userList = () => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.get('/user/getAll', {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then((response) => {
                dispatch({
                    type: USER_LIST,
                    payload: response.data.data
                })

            }).catch(err => {
                if (err.response) {
                    console.log(err.response.data.message)
                } else {
                    alert(err.message)
                }
            });
    }
}
export const allEngineers = () => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.get('/user/getEngineers', {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then((response) => {
                dispatch({
                    type: ENGINEER_LIST,
                    payload: response.data.successResponse
                })

            }).catch(err => {
                if (err.response) {
                    console.log(err.response.data.message)
                } else {
                    alert(err.message)
                }
            });
    }
}

export const EngineersAdmins = () => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.get('/user/engineers_admins', {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then((response) => {
                dispatch({
                    type: ENGINEER_ADMINS,
                    payload: response.data.successResponse
                })

            }).catch(err => {
                if (err.response) {
                    console.log(err.response.data.message)
                } else {
                    alert(err.message)
                }
            });
    }
}

export const addUser = (data: any) => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        console.log("addUser", data);
        Api.post('/user/add', data, {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then((response) => {
                console.log("response", response);
                window.location.href = "/users";

            }).catch(err => {
                console.log("err", err);
                if (err.response) {
                    console.log("err.response", err.response)
                    let error;
                    if (typeof (err.response.data.message) === "string") {
                        if (err.response.data.code === "ER_DUP_ENTRY") {
                            error = "UserName Already Exist";
                        } else {
                            error = err.response.data.message;
                        }
                    } else if (typeof (err.response.data.message) === "object") {
                        error = err.response.data.message[0].replace(/_/g, " ");
                    }
                    if (error) {
                        toast.error(error, { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 3000 });
                    }
                    console.log(err.response.data.message);
                } else {
                    toast.error(err.message, { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 3000 });
                }
            });
    }
}

export const getUser = (id: any) => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.get(`/user/get/${id}`,
            {
                headers: { 'Authorization': 'Bearer ' + token }
            })
            .then((response) => {
                console.log("response", response);
                dispatch({
                    type: USER_GET,
                    payload: response.data.data
                })

            }).catch(err => {
                if (err.response) {
                    console.log(err.response.data.message)
                } else {
                    alert(err.message)
                }
            });
    }
}

export const getUserProfile = (id: any) => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.get(`/user/getUserProfile/${id}`,
            {
                headers: { 'Authorization': 'Bearer ' + token }
            })
            .then((response) => {
                console.log("response", response);
                dispatch({
                    type: USER_GET,
                    payload: response.data.data
                })

            }).catch(err => {
                if (err.response) {
                    console.log(err.response.data.message)
                } else {
                    alert(err.message)
                }
            });
    }
}
export const getCourseGroupByUser = (id: any) => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.get(`/user/getCourseGroupUser/${id}`,
            {
                headers: { 'Authorization': 'Bearer ' + token }
            })
            .then((response) => {
                console.log("response", response);
                dispatch({
                    type: USERS_BY_COURSE_GROUPS,
                    payload: response.data.data
                })

            }).catch(err => {
                if (err.response) {
                    console.log(err.response.data.message)
                } else {
                    alert(err.message)
                }
            });
    }
}
export const updateUser = (id: any, data: any) => {
    return function (dispatch: any) {
        let token: string | null = sessionStorage.getItem('token');
        if (!token) {
            console.error("No authentication token found.");
            alert("You are not logged in.");
            return;
        }
        const config = {
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        };

        Api.put(`/user/update/${id}`, data, config)
            .then((response) => {
                window.location.href = "/users";
            })
            .catch(err => {
                if (err.response) {
                    console.error("Error response:", err.response.data);
                    toast.error(err.response.data.message || "Failed to update user.", { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 3000 });
                } else if (err.request) {
                    console.error("No response received:", err.request);
                    toast.info("No response from server. Please check your connection.", { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 3000 });
                } else {
                    console.error("Error:", err.message);
                    toast.error(`An error occurred: ${err.message}`, { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 3000 });
                }
            });
    };
};
export const updateProfile = (id: string | number, data: FormData) => {
    return async (dispatch: any) => {
      try {
        const token = sessionStorage.getItem('token');
        if (!token) {
          throw new Error('Authentication required');
        }
  
        const response = await Api.put(`/user/profile`, data, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        });
  
        const { file } = response.data;
        if (file && file !== '') {
          sessionStorage.setItem('profileImage', file);
        }
  
        toast.success('Profile updated successfully!');
  
      } catch (err: any) {
        let message = 'An error occurred';
  
        if (err.response?.data?.message) {
          message = err.response.data.message;
        } else if (err.message) {
          message = err.message;
        }
  
        toast.error(`Profile update failed: ${message}`);
        console.error('Update profile error:', err);
      }
    };
  };
export const updatePassword = (id: any, data: any) => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.post(`/authentication/update-password-by-admin`, data, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        })
            .then((response) => {
                console.log("response", response);
                toast.success("Password updated successfully. Please login again.", { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 3000 });
                setTimeout(() => {
                    sessionStorage.clear();
                    window.location.href = "/";
                }, 2000);

            }).catch(err => {
                if (err.response) {
                    console.log(err.response.data.message)
                    let error;
                    if (typeof (err.response.data.message) === "string") {
                        error = err.response.data.message;
                    } else if (typeof (err.response.data.message) === "object") {
                        error = err.response.data.message[0];
                    } else {
                        error = "Failed to update password";
                    }
                    toast.error(error, { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 3000 });
                } else {
                    toast.error(err.message, { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 3000 });
                }
            });
    }
}
export const deleteUser = (id: any) => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.put(`/user/delete/${id}`, {}, {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then((response) => {
                console.log("response", response);
                window.location.href = "/users";
            }).catch(err => {
                if (err.response) {
                    console.log(err.response.data.message)
                } else {
                    alert(err.message)
                }
            });
    }
}

export const loginUser = (email: any, password: any) => {
    return async function (dispatch: any) {
        try {
            const { data: responseData } = await Api.post('authentication/auth', { email, password });
            const { success, data: payload, message } = responseData || {};
            const userData = payload || {};

            if (!success || !userData.success) {
                const errorMessage = message || userData.message || "Unable to login.";
                dispatch({
                    type: LOGIN_USER,
                    payload: errorMessage,
                    isLoggedIn: false
                });
                return;
            }

            const {
                accessToken,
                userId,
                name,
                email: userEmail,
                username,
                company,
                role,
                profileImage
            } = userData;

            if (!accessToken || !userId) {
                dispatch({
                    type: LOGIN_USER,
                    payload: "Incomplete user data received.",
                    isLoggedIn: false
                });
                return;
            }

            const sessionValues: Record<string, any> = {
                userId,
                name,
                role,
                email: userEmail,
                username,
                company,
                profileImage,
                token: accessToken
            };

            Object.entries(sessionValues).forEach(([key, value]) => {
                if (value === undefined || value === null) {
                    return;
                }
                sessionStorage.setItem(key, value);
            });

            const routeByRole: Record<number, string> = {
                5: "/tickets",
                3: "/requester"
            };

            window.location.href = routeByRole[role] || "/dashboard";
        } catch (err: any) {
            const responseMessage = err?.response?.data?.message;
            const messageToShow = typeof responseMessage === "string"
                ? responseMessage
                : Array.isArray(responseMessage)
                    ? responseMessage[0]
                    : err?.message || "Login failed.";
            dispatch({
                type: LOGIN_USER,
                payload: messageToShow,
                isLoggedIn: false
            });
        }
    }
}

export const courseGroupList = () => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.get('/course/getAllCourseGroups')
            // {
            //     headers: { 'Authorization': 'Bearer ' + token }
            // })
            .then((response) => {
                console.log("course groups respone", response);

                dispatch({
                    type: COURSE_GROUP_LIST,
                    payload: response.data.data
                })

            }).catch(err => {
                if (err.response) {
                    console.log(err.response.data.message)
                } else {
                    alert(err.message)
                }
            });
    }
}

export const logoutUser = () => {
    return function (dispatch: any) {
        sessionStorage.clear();
        window.location.href = "/"
    }
}

export const forgotPassword = (email: any) => {
    return function (dispatch: any) {
        Api.post('/authentication/forgot-password', {
            email: email
        })
            .then((response) => {
                if (response.data.success) {
                    toast.success("Password reset successful! Please check your email for the new password. Redirecting to login...", {
                        position: toast.POSITION.TOP_RIGHT,
                        hideProgressBar: false,
                        autoClose: 3000
                    });
                    setTimeout(() => {
                        window.location.href = "/";
                    }, 2500);
                } else if (response.data.success == false) {
                    let error;
                    if (typeof (response.data?.message) === "string") {
                        error = response.data.message;
                    } else if (typeof (response.data?.message) === "object") {
                        error = response.data.message[0];
                    }
                    toast.error(error, { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 3000 });
                }
            }).catch(err => {
                if (err.response) {
                    let error;
                    if (typeof (err.response.data.message) === "string") {
                        error = err.response.data.message;
                    } else if (typeof (err.response.data.message) === "object") {
                        error = err.response.data.message[0];
                    }
                    toast.error(error, { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 3000 });
                } else {
                    toast.error(err.message || "An error occurred. Please try again.", { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 3000 });
                }
            });
    }
}